import { I18nLookup } from 'pricing-pages-lib/utils/languageUtils';

/**
 * This function will add the suffix to the final characters but preserve the _jsx ending
 * needed to render FormattedJSXMessages properly
 * Example where suffix is CP:
 * foo.bar => foo.barCP
 * foo.bar_jsx => foo.barCP_jsx
 * foo.bar_foo => foo.bar_fooCP
 */
export function getCopyChangeKey(key, suffix) {
  return key.replace(/(_jsx)?$/, `${suffix}$1`);
}
export function getMarketingPlusCopyChangeKey(key) {
  const newKey = getCopyChangeKey(key, 'Nov2024');
  return I18nLookup(newKey) ? newKey : key;
}
export function getInbound25CopyChangeKey(key) {
  const newKey = getCopyChangeKey(key, 'Inbound25');
  return I18nLookup(newKey) ? newKey : key;
}